module.exports = __webpack_public_path__ + "static/media/video.8e990d48.mp4";